import { currentSnackbarState } from '@databases/snackbar/snackbar';
import { generateId } from '@databases/utils/utils';

import { FlagProps } from './types';

const flags: Array<
  FlagProps & {
    /** Internal flag randomly generated ID. */
    _id: string;
  }
> = [];

/**
 * Re-renders the AtlasKit flag group component with the flags from the flags array.
 */
function renderAtlasKitFlags() {
  flags.forEach((flag) => {
    if (flag.body) {
      const message = flag.bodyI18nId || flag.body;

      currentSnackbarState.setMessage(message, {
        showCloseButton: flag.showCloseButton ?? true,
        messageData: flag.actions,
        onDismiss: flag.onDismiss,
        timeout: flag.timeout,
        i18nVariables: flag.i18nVariables,
      });
    }
  });
}

export async function addFlag(flag: FlagProps): Promise<void> {
  if (flag.id) {
    removeFlag(flag.id);
  }

  flags.push({
    ...flag,
    _id: generateId(),
  });
  renderAtlasKitFlags();
}

export function removeFlag(flagId: string): void {
  for (let i = 0; i < flags.length; i++) {
    if (flags[i].id === flagId) {
      currentSnackbarState.clearMessage(flags[i].body);
      flags.splice(i--, 1);
    }
  }
}
